<template>
  <div class="app-container">
    <el-row :gutter="10">
      <dynamic-split-pane :default-percent="18">
        <template v-slot:left>
          <el-col>
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>组织</span>
              </div>
              <div>
                <el-input
                  v-model="deptName"
                  clearable
                  placeholder="输入部门名称搜索"
                  prefix-icon="el-icon-search"
                  class="filter-item"
                  @input="searchDept"/>
                <div class="tree-container-scroll">
                  <el-scrollbar>
                    <tree
                      class="org-tree"
                      ref="orgTree"
                      keyField="id"
                      :data="treeData"
                      :prop="treeProps"
                      :expand-on-click-node="false"
                      :filter-node="filterNode"
                      @change="change"/>
                  </el-scrollbar>
                </div>
              </div>
            </el-card>
          </el-col>
        </template>
        <template v-slot:right>
          <el-col>
            <el-card class="box-card">
              <!--form 组件-->
              <eForm ref="form" :is-add="isAdd" :tree-data.sync="treeData" :sup-this="supThis"/>
              <!-- 搜索-->
              <dynamic-search
                :data="tableFilterList(tableHead)"
                @search="dataTableSearch">
                <template v-slot:next>
                  <el-button
                    type="primary"
                    icon="el-icon-plus"
                    @click="subAdd">新增
                  </el-button>
                </template>
              </dynamic-search>
              <div class="data-table-box">
                <edit-data-table
                  :loading="loading"
                  :head="tableHead"
                  rowKeyField="id"
                  ref="editTable"
                  show-number
                  :data.sync="list"
                  :total="total"
                  :offset="offset"
                  :page="page"
                  stripe
                  @handlePageChange="dataTablePageChange"
                  @handleSizeChange="dataTableSizeChange">
                  <template v-slot:toolbar="{row}">
                    <el-button size="mini" type="text" icon="el-icon-edit" @click="edit(row)"/>
                    <el-popover :ref="row.id" placement="top" width="180">
                      <p>确定删除本条数据吗？</p>
                      <div style="text-align: right; margin: 0">
                        <el-button size="mini" type="text" @click="$refs[row.id].doClose()">
                          取消
                        </el-button>
                        <el-button
                          :loading="delLoading"
                          type="primary"
                          size="mini"
                          @click="subDelete(row.id)">确定
                        </el-button>
                      </div>
                      <el-button type="text" size="mini" icon="el-icon-delete" slot="reference" class="table-del-btn"></el-button>
                    </el-popover>
                  </template>
                </edit-data-table>
              </div>
            </el-card>
          </el-col>
        </template>
      </dynamic-split-pane>
    </el-row>
  </div>
</template>

<script>
  import Tree from '@/components/Tree/index.vue'
  import "@/components/EditDataTable"
  import DynamicSearch from '@/components/DynamicSearch/index.vue'
  import DynamicSplitPane from '@/components/DynamicSplitPane/index.vue'
  import DataTableMixin from '@/mixins/DataTableMixin'
  import initDict from '@/mixin/initDict'
  import {del} from '@/api/job'
  import {getDeptTree} from '@/api/dept'
  import eForm from './form'
  import {deepClone} from '@/utils/index'

  export default {
    name: "Job",
    mixins: [DataTableMixin, initDict],
    components: {
      Tree,
      DynamicSearch,
      DynamicSplitPane,
      eForm
    },
    data() {
      return {
        delLoading: false,
        isAdd: false,
        supThis: this,
        treeData: [],
        treeProps: {
          children: 'children',
          label: 'name'
        },
        tableHead: [
          {
            label: '职位名称',
            prop: 'name',
            query: {
              type: 'input'
            },
          }, {
            label: '职位编码',
            prop: 'code'
          }, {
            label: '所属组织',
            prop: 'deptName',
          }, {
            label: '排序号',
            prop: 'sort',
            width: 100,
            sortable: true,
          }, {
            label: '创建时间',
            prop: 'created',
            width: 160,
            sortable: true,
          },
        ],
        deptId: "",
        deptName: ""
      }
    },
    created() {
      this.$nextTick(() => {
        this.getDeptDatas()
        this.dataTableInit()
      })
    },
    methods: {
      dataTableBeforeInit() {
        this._url = '/job'
        const params = {page: this.page, size: this.offset, deptId: this.deptId}
        this._params = Object.assign(params, this._query)
        return true
      },
      handleDeletes(rows) {
        rows.forEach(element => {
          this.subDelete(element.id)
        });
      },
      subAdd() {
        this.$refs.form.form = {sort: this.total + 1}
        this.$refs.form.dialog = true;
        this.isAdd = true
      },
      subDelete(id) {
        this.delLoading = true
        del(encodeURIComponent(id)).then(res => {
          this.delLoading = false
          this.$refs[id].doClose()
          this.dleTableChangePage()
          this.dataTableInit()
          this.$notify({
            title: '删除成功',
            type: 'success',
            duration: 2500
          })
        }).catch(err => {
          this.delLoading = false
          this.$refs[id].doClose()
          console.log(err)
        })
      },
      edit(data) {
        this.isAdd = false
        const _this = this.$refs.form
        _this.form = deepClone(data)
        _this.dialog = true
      },
      change(data) {
        if (data.pid === 0) {
          this.deptId = null
        } else {
          this.deptId = data.id
        }
        this.dataTableInit()
      },
      getDeptDatas() {
        getDeptTree().then(res => {
          this.treeData = res.data
        })
      },
      searchDept() {
        this.$refs.orgTree.$refs.tree.filter(this.deptName);
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
      }
    }
  }
</script>

<style scoped lang="scss">

  .tree-container-scroll {
    padding-top: 15px;
    height: 400px;

    /deep/ .el-scrollbar__wrap {
      overflow-x: auto;
    }
  }

  /deep/ .splitter-pane-resizer {
    background-color: #ffffff;
  }
</style>
